import { render, staticRenderFns } from "./PromotionalTags.vue?vue&type=template&id=02f6c19c&"
import script from "./PromotionalTags.vue?vue&type=script&lang=js&"
export * from "./PromotionalTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports